import React, { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Chip,
    Card,
    CardContent,
    Link,
    Button,
    Avatar
} from '@mui/material';

import {
    CleaningServices,
    ShoppingCart,
    ThumbUpAlt,
    CheckCircle,
    Group,
    Star,
    LocalOffer,
    Home,
    DeleteSweep,
    EmojiPeople,
    AttachMoney
} from '@mui/icons-material';

// スクロール用の関数
const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
        const offset = 80; // ヘッダーの高さ分のオフセット
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};

const PostContent = () => {
    const [showToc, setShowToc] = useState(true);
    return (
        <Box sx={{ maxWidth: 800, mx: 'auto', px: 3 }}>
            {showToc ? (
                <Card sx={{ mb: 4, boxShadow: 2, bgcolor: '#e3f2fd', border: '1px solid #ddd', borderRadius: 2 }}>
                    <CardContent sx={{ p: 2 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                            <Typography variant="h6" sx={{ flexGrow: 1 }}>目次</Typography>
                            <Button variant="outlined" size="small" onClick={() => setShowToc(false)}>閉じる</Button>
                        </Box>
                        <List sx={{ p: 0 }}>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    1.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('introduction')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアで掃除グッズが重要な理由
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    2.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('recommend-goods')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    ルームシェアにおすすめの掃除グッズ5選
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    3.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('usage-effect')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    便利掃除グッズの使い方と効果
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    4.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('joint-purchase')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    共同購入のコツとトラブル回避術
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    5.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('experiences')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    実際の体験談＆掃除で仲良くなるコツ
                                </Link>
                            </ListItem>
                            <ListItem sx={{ p: 0.5, display: 'flex', alignItems: 'center' }}>
                                <Box sx={{ minWidth: 32, minHeight: 32, bgcolor: '#f5f5f5', color: '#888', fontWeight: 'bold', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1, fontSize: '1.1rem' }}>
                                    6.
                                </Box>
                                <Link component="button" onClick={() => scrollToSection('summary')} color="inherit" underline="hover" sx={{ cursor: 'pointer', fontSize: '0.95rem' }}>
                                    まとめ＆おすすめグッズ再掲
                                </Link>
                            </ListItem>
                        </List>
                    </CardContent>
                </Card>
            ) : (
                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setShowToc(true)}
                    sx={{ mb: 2 }}
                >
                    目次を表示
                </Button>
            )}

            {/* 導入部分 */}
            <Box id="introduction" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアで掃除グッズが重要な理由
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
                    ルームシェア生活、楽しいけれど「掃除」は意外とトラブルの元。誰が何を、どのくらいの頻度で、どんな方法で掃除するか——そんな悩み、ありませんか？
                </Typography>
                <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
                    しかし、便利な掃除グッズを賢く選べば、掃除の負担も時間もぐっと軽減！共有スペースがいつも清潔に保たれることで、ルームメイト同士のストレスも減り、気持ちよく過ごせます。
                </Typography>
                <Box sx={{ my: 3 }}>
                    
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    本記事では、「ルームシェア向けおすすめ掃除グッズ」とその活用術、みんなで購入する際のコツやリアルな体験談まで、専門的な視点で詳しくご紹介します。
                </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* おすすめ掃除グッズ */}
            <Box id="recommend-goods" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    ルームシェアにおすすめの掃除グッズ5選
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェア経験者の声やプロの現場でも高評価！特に「共有スペース」に強い、コスパ・時短・衛生面に優れた定番アイテムを厳選してご紹介します。
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, height: '100%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <CleaningServices sx={{ color: '#1976d2', mr: 1 }} />
                                    <Typography variant="h6">1. コードレス掃除機</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    軽量＆パワフル、コードレスで階段やリビングもラクラク。共有スペースの「ちょっと気になった時」に誰でもサッと使えるのが最大の魅力です。
                                </Typography>
                                <Chip label="時短" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="手軽" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, height: '100%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <DeleteSweep sx={{ color: '#388e3c', mr: 1 }} />
                                    <Typography variant="h6">2. 使い捨てフロアワイパー</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    ホコリや髪の毛、細かなゴミをしっかりキャッチ。シートを交換するだけなので、清潔好きな人にも◎。
                                </Typography>
                                <Chip label="衛生的" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="簡単" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, height: '100%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Star sx={{ color: '#fbc02d', mr: 1 }} />
                                    <Typography variant="h6">3. 多目的クリーナーシート</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    テーブル、キッチン、ドアノブ、リモコン…一枚でサッと拭き掃除。除菌タイプならさらに安心です。
                                </Typography>
                                <Chip label="除菌" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="オールインワン" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, height: '100%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <LocalOffer sx={{ color: '#0288d1', mr: 1 }} />
                                    <Typography variant="h6">4. マイクロファイバークロス</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    洗面台やキッチンの水アカ、窓ガラスの曇りもピカピカ。洗って繰り返し使えるのでコスパも◎。
                                </Typography>
                                <Chip label="エコ" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="高コスパ" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Card sx={{ maxWidth: 345, height: '100%' }}>
                            <CardContent>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <ShoppingCart sx={{ color: '#d32f2f', mr: 1 }} />
                                    <Typography variant="h6">5. ゴミ袋自動ストッカー</Typography>
                                </Box>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    「ゴミ袋どこ？」がなくなる！袋をサッとセットできて、補充も簡単。分別用に複数個あるとさらに便利。
                                </Typography>
                                <Chip label="整理整頓" color="primary" variant="outlined" size="small" sx={{ mr: 1 }} />
                                <Chip label="時短" color="success" variant="outlined" size="small" />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 便利グッズの使い方と効果 */}
            <Box id="usage-effect" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    便利掃除グッズの使い方と効果
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    「便利そうだけど、使いこなせるかな？」そんな不安も大丈夫。ここでは各グッズの賢い使い方と、実際の効果を解説します。
                </Typography>
                <Paper sx={{ p: 2, mb: 3, borderRadius: 2, background: '#f6f9fb' }} elevation={0}>
                    <List>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <CleaningServices sx={{ color: '#1976d2' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<strong>コードレス掃除機</strong>}
                                secondary="充電しておけば、思い立ったタイミングで誰でも使えます。軽量なので女性やお子さんもOK。リビングや廊下、階段など共有部分に1台置いておくのがおすすめです。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <DeleteSweep sx={{ color: '#388e3c' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<strong>使い捨てフロアワイパー</strong>}
                                secondary="床のホコリや髪の毛が気になるとき、サッと一拭き。毎日の“気づいた人”が手軽に掃除でき、シート交換だけなので清潔感もキープ。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <Star sx={{ color: '#fbc02d' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<strong>多目的クリーナーシート</strong>}
                                secondary="ドアノブやスイッチ、テーブルなど“みんなが触れる場所”の除菌に。アルコールタイプなら感染症対策にも役立ちます。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <LocalOffer sx={{ color: '#0288d1' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<strong>マイクロファイバークロス</strong>}
                                secondary="水だけでも汚れを落とせ、洗って繰り返し使えるので経済的。水回りや窓、鏡もピカピカに。"
                            />
                        </ListItem>
                        <ListItem alignItems="flex-start">
                            <ListItemIcon>
                                <ShoppingCart sx={{ color: '#d32f2f' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary={<strong>ゴミ袋自動ストッカー</strong>}
                                secondary="ゴミ袋が切れたり探したり…のストレスが激減。分別ごとに設置すれば、ゴミ出しもスムーズです。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/cleaning-goods-table_roomshare-osusume-cleaning-goods.jpg"
                        alt="共有テーブルに並べられたコードレス掃除機、フロアワイパー、多目的クリーナーシート、マイクロファイバークロス、ゴミ袋ストッカーなどの掃除グッズ。明るい自然光と整然としたレイアウトが清潔感を強調している。"
                        width="100%"
                        style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.10)' }}
                    />
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    <CheckCircle sx={{ color: '#388e3c', verticalAlign: 'middle', mr: 0.5 }} fontSize="small" />
                    ポイント：掃除グッズは「誰でも・すぐに・迷わず」使えることが大切。収納場所も全員で共有しておくと、さらに使い勝手がアップします。
                </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 共同購入のコツ */}
            <Box id="joint-purchase" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    共同購入のコツとトラブル回避術
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    掃除グッズは「みんなで使う」ものだからこそ、購入やコスト分担が曖昧だと後々トラブルに…。円満に進めるためのコツをまとめました。
                </Typography>
                <Paper sx={{ p: 2, mb: 3, borderRadius: 2, background: '#f1f8e9' }} elevation={0}>
                    <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Group sx={{ color: '#4caf50', mr: 1 }} />
                        <strong>共同購入ポイント3選</strong>
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <AttachMoney sx={{ color: '#43a047' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="事前に「何をどれだけ買うか」をリストアップ"
                                secondary="みんなで必要なアイテムを出し合い、リスト化。予算感も最初に話し合っておきましょう。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ShoppingCart sx={{ color: '#388e3c' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="購入・支払いは「代表者＆レシート共有」"
                                secondary="代表者が購入し、レシート画像をグループチャット等でシェア。後で割り勘精算するとトラブル防止に。"
                            />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ThumbUpAlt sx={{ color: '#1976d2' }} />
                            </ListItemIcon>
                            <ListItemText
                                primary="“消耗品の補充”は「担当を決めてローテーション」"
                                secondary="シートやゴミ袋など定期的な補充は、担当者を決めて月ごとローテーションすると負担が偏りません。"
                            />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                    <CheckCircle sx={{ color: '#388e3c', verticalAlign: 'middle', mr: 0.5 }} fontSize="small" />
                    トラブル防止のためにも「購入・管理ルール」を可視化し、共有スペースやグループチャットで誰でも見られるようにしておくのがベストです。
                </Typography>
                <Box sx={{ my: 3 }}>
                    <img
                        src="/images/blog/joint-purchase_roomshare-osusume-cleaning-goods.jpg"
                        alt="共有キッチンカウンターでルームメイトたちが共同購入した掃除グッズのレシートを確認し合い、笑顔で話し合う場面。明るい雰囲気と整理された掃除道具が、協力的なルームシェアの一体感を象徴している。"
                        width="100%"
                        style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.10)' }}
                    />
                </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 体験談 */}
            <Box id="experiences" sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    実際の体験談＆掃除で仲良くなるコツ
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアでよく聞く「掃除あるある」や、実際に掃除グッズを導入して変わった！というリアルな声をピックアップしました。
                </Typography>
                <Box sx={{ mb: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#fffde7' }} elevation={0}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar src="/images/avatars/user1.jpg" sx={{ width: 36, height: 36, mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Yさん（20代・女性）</Typography>
                                </Box>
                                <Typography variant="body2">
                                    「フロアワイパーを導入してから、みんな“気づいた時にサッと”掃除するように。掃除のストレスが減ったせいか、雑談の機会も増えました！」
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#e3f2fd' }} elevation={0}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar src="/images/avatars/user2.jpg" sx={{ width: 36, height: 36, mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Kさん（30代・男性）</Typography>
                                </Box>
                                <Typography variant="body2">
                                    「コードレス掃除機を共有スペースに置くだけで、部屋全体がこまめにキレイに。シンプルだけど、これだけで空気感が変わりました！」
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper sx={{ p: 2, borderRadius: 2, bgcolor: '#f1f8e9' }} elevation={0}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <Avatar src="/images/avatars/user3.jpg" sx={{ width: 36, height: 36, mr: 1 }} />
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>Tさん（40代・女性）</Typography>
                                </Box>
                                <Typography variant="body2">
                                    「掃除グッズの共同購入を“担当制”にしたら、公平感があってモヤモヤ解消。グループLINEでレシートをシェアするだけでトラブルもゼロに！」
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                    <EmojiPeople sx={{ color: '#1976d2', verticalAlign: 'middle', mr: 0.5 }} fontSize="small" />
                    掃除は「仲良くなる」きっかけにも！手伝い合いや声かけで自然と会話も増え、より快適なルームシェアライフにつながります。
                </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* まとめ */}
            <Box id="summary" sx={{ mb: 6 }}>
                <Typography variant="h4" component="h2" gutterBottom>
                    まとめ＆おすすめグッズ再掲
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ルームシェアで快適な共同生活を送るには、「みんなが使いやすい掃除グッズ」と「ルールの可視化・共有」がカギです。掃除のしやすさは、日々のストレスや人間関係に大きく影響します。
                </Typography>
                <Paper sx={{ p: 2, borderRadius: 2, background: '#fff', boxShadow: 1 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 'bold' }}>
                        【今回ご紹介したおすすめ掃除グッズ】
                    </Typography>
                    <List>
                        <ListItem>
                            <ListItemIcon>
                                <CleaningServices sx={{ color: '#1976d2' }} />
                            </ListItemIcon>
                            <ListItemText primary="コードレス掃除機" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <DeleteSweep sx={{ color: '#388e3c' }} />
                            </ListItemIcon>
                            <ListItemText primary="使い捨てフロアワイパー" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <Star sx={{ color: '#fbc02d' }} />
                            </ListItemIcon>
                            <ListItemText primary="多目的クリーナーシート" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <LocalOffer sx={{ color: '#0288d1' }} />
                            </ListItemIcon>
                            <ListItemText primary="マイクロファイバークロス" />
                        </ListItem>
                        <ListItem>
                            <ListItemIcon>
                                <ShoppingCart sx={{ color: '#d32f2f' }} />
                            </ListItemIcon>
                            <ListItemText primary="ゴミ袋自動ストッカー" />
                        </ListItem>
                    </List>
                </Paper>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
                    ぜひ、あなたのルームシェアにも「便利掃除グッズ」＆「みんなで使える仕組み」を取り入れて、もっと快適な暮らしを始めてみませんか？
                </Typography>
            </Box>
        </Box>
    );
};

const post = {
    id: 'roomshare-osusume-cleaning-goods',
    slug: 'roomshare-osusume-cleaning-goods',
    title: 'ルームシェアの「おすすめ掃除グッズ」特集',
    excerpt: '便利掃除グッズ紹介 使い方と効果 共同購入のコツ 体験談',
    coverImage: '/images/blog/cover-roomshare-clean-goods_roomshare-osusume-cleaning-goods.jpg',
    coverImageAlt: '明るい自然光が差し込むモダンなルームシェアの共有リビングで、多様な背景を持つルームメイトたちが楽しく会話をしている様子。インテリアや掃除グッズが整然と配置され、清潔感と協力的な雰囲気、快適な共同生活の魅力を伝えている。',
    publishedAt: '2024-06-19T00:00:00+09:00',
    isPublished: true,
    categories: ['ルームシェア', '掃除・衛生', '生活術'],
    tags: ['掃除グッズ', 'ルームシェア', '共同購入', '快適生活'],
    author: {
        name: '柳瀬 純一',
        avatar: '/images/avatars/yanase-junichi.jpg',
        bio: 'ルームシェア・共同生活の現場経験15年以上。住まい選びと日常管理を軸に「快適な暮らし」を追求するライター＆コンサルタント。',
        profilePicture: '/images/avatars/yanase-junichi.jpg'
    },
    viewCount: 1350,
    contentComponent: PostContent
};

export default post;